/*
 * ============================================================
 * argile-reservation.js — formulaire multistep « Réserver un conseil »
 * ============================================================
 * Chargé PAR la section (cf. sections/argile-reservation.liquid).
 *
 * Cible `[data-reservation-form]` (formulaire de contact natif Shopify).
 * Gère : navigation entre étapes (Précédent / Suivant), validation par étape,
 * puces multi-choix (→ champ caché joint), et soumission AJAX (fetch) avec
 * bascule vers l'état SUCCÈS ou ERREUR — sans rechargement de page.
 */
(function () {
  'use strict';

  function initReservation(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('[data-reservation-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form.dataset.argileWired) return;
      form.dataset.argileWired = '1';

      var successState = form.querySelector('[data-state-success]');
      var errorState = form.querySelector('[data-state-error]');

      // États rendus côté serveur (après envoi natif) : on remonte dessus.
      if (successState) {
        successState.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (errorState) {
        errorState.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      var stepsWrap = form.querySelector('[data-reservation-steps]');
      var steps = [].slice.call(form.querySelectorAll('.argile-reservation__step'));
      if (!steps.length) return; // état succès : aucun formulaire à câbler

      var piecesOutput = form.querySelector('[data-pieces-output]');
      var pieceInputs = [].slice.call(form.querySelectorAll('[data-piece]'));
      var daysOutput = form.querySelector('[data-days-output]');
      var dayInputs = [].slice.call(form.querySelectorAll('[data-day]'));
      var conds = [].slice.call(form.querySelectorAll('[data-cond]'));
      var submitBtn = form.querySelector('[data-submit]');

      var current = 0;

      // Un nœud est-il réellement visible (≠ conditionnel masqué) ?
      function isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      }

      function showStep(index) {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach(function (step, i) {
          step.classList.toggle('is-active', i === current);
        });
        // Barre de progression : étape courante / total
        var pct = ((current + 1) / steps.length) * 100;
        form.style.setProperty('--resv-progress', pct + '%');
        // Remonte le panneau en haut pour les longues étapes
        var top = form.getBoundingClientRect().top;
        if (top < 0) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // ── Validation d'une étape ──
      function clearError(field) { if (field) field.classList.remove('has-error'); }

      function validateStep(step) {
        var ok = true;
        var firstInvalid = null;
        var required = [].slice.call(step.querySelectorAll('[data-required]'));

        required.forEach(function (node) {
          // Un champ conditionnel masqué n'est pas validé.
          if (!isVisible(node)) return;
          var field = node.closest('.argile-reservation__field') || node;
          var valid = true;

          if (node.tagName === 'FIELDSET') {
            valid = !!node.querySelector('input:checked');
          } else if (typeof node.checkValidity === 'function') {
            valid = node.value.trim() !== '' && node.checkValidity();
          }

          field.classList.toggle('has-error', !valid);
          if (!valid) {
            ok = false;
            if (!firstInvalid) firstInvalid = node;
          }
        });

        if (firstInvalid && typeof firstInvalid.focus === 'function') {
          if (firstInvalid.tagName === 'FIELDSET') {
            var inp = firstInvalid.querySelector('input');
            if (inp) inp.focus();
          } else {
            firstInvalid.focus();
          }
        }
        return ok;
      }

      // ── Navigation ──
      form.addEventListener('click', function (event) {
        var nextBtn = event.target.closest('[data-next]');
        var prevBtn = event.target.closest('[data-prev]');
        if (nextBtn) {
          event.preventDefault();
          if (validateStep(steps[current])) showStep(current + 1);
        } else if (prevBtn) {
          event.preventDefault();
          showStep(current - 1);
        }
      });

      // ── Champs conditionnels (affichés selon un choix précédent) ──
      // Valeurs actuellement sélectionnées pour une clé de contrôle donnée.
      function condSourceValues(key) {
        if (key === 'pieces') {
          return pieceInputs.filter(function (i) { return i.checked; })
            .map(function (i) { return i.value; });
        }
        var vals = [];
        [].slice.call(form.querySelectorAll('[data-cond-key="' + key + '"]')).forEach(function (el) {
          if (el.tagName === 'SELECT') {
            if (el.value) vals.push(el.value);
          } else if (el.type === 'radio' || el.type === 'checkbox') {
            if (el.checked) vals.push(el.value);
          } else if (el.value) {
            vals.push(el.value);
          }
        });
        return vals;
      }
      // Vide les contrôles d'un bloc conditionnel qu'on masque (pas de données fantômes).
      function resetCond(el) {
        [].slice.call(el.querySelectorAll('input, select, textarea')).forEach(function (c) {
          if (c.type === 'radio' || c.type === 'checkbox') c.checked = false;
          else c.value = '';
        });
        [].slice.call(el.querySelectorAll('.has-error')).forEach(function (f) { f.classList.remove('has-error'); });
      }
      // Itère dans l'ordre du DOM → les conditions chaînées se résolvent en cascade
      // (masquer « accompagné » réinitialise « type de pro » qui se masque ensuite).
      function refreshConds() {
        conds.forEach(function (el) {
          var key = el.getAttribute('data-cond-when');
          var eq = el.getAttribute('data-cond-eq');
          var match = condSourceValues(key).indexOf(eq) !== -1;
          if (match) {
            el.hidden = false;
          } else {
            el.hidden = true;
            resetCond(el);
          }
        });
      }

      // Efface l'erreur d'un champ dès qu'on le corrige
      form.addEventListener('input', function (event) {
        var field = event.target.closest('.argile-reservation__field');
        clearError(field);
      });
      form.addEventListener('change', function (event) {
        var field = event.target.closest('.argile-reservation__field');
        clearError(field);
        refreshConds();
      });

      // ── Puces multi-choix → champ caché ──
      function syncPieces() {
        if (!piecesOutput) return;
        var values = pieceInputs.filter(function (i) { return i.checked; })
          .map(function (i) { return i.value; });
        piecesOutput.value = values.join(', ');
      }
      pieceInputs.forEach(function (i) { i.addEventListener('change', syncPieces); });

      function syncDays() {
        if (!daysOutput) return;
        var values = dayInputs.filter(function (i) { return i.checked; })
          .map(function (i) { return i.value; });
        daysOutput.value = values.join(', ');
      }
      dayInputs.forEach(function (i) { i.addEventListener('change', syncDays); });

      // ── Réessayer (état erreur rendu serveur) : on ré-affiche le formulaire ──
      if (errorState) {
        var retry = errorState.querySelector('[data-retry]');
        if (retry) {
          retry.addEventListener('click', function () {
            errorState.hidden = true;
            if (stepsWrap) stepsWrap.hidden = false;
            showStep(0);
          });
        }
      }

      // ── Soumission NATIVE (compatible captcha Shopify) ──
      // Pas d'AJAX : on valide l'étape, puis on laisse Shopify soumettre le
      // formulaire. Au rechargement, l'état succès/erreur est rendu par Liquid.
      form.addEventListener('submit', function (event) {
        // N'autoriser l'envoi que depuis la dernière étape (évite un envoi sur
        // « Entrée » dans un champ d'une étape intermédiaire).
        if (current < steps.length - 1) {
          event.preventDefault();
          if (validateStep(steps[current])) showStep(current + 1);
          return;
        }
        if (!validateStep(steps[current])) {
          event.preventDefault();
          return;
        }
        // Étape finale valide → synchroniser les puces puis laisser l'envoi natif.
        syncPieces();
        syncDays();

        // État « envoi en cours » : transforme le reload natif en transition voulue.
        if (stepsWrap) stepsWrap.classList.add('is-submitting');
        if (submitBtn) {
          submitBtn.setAttribute('aria-busy', 'true');
          var lbl = submitBtn.querySelector('[data-submit-label]');
          var submitting = submitBtn.getAttribute('data-submitting-label');
          if (lbl && submitting) lbl.textContent = submitting;
          // désactivation différée pour ne pas annuler la soumission native en cours
          setTimeout(function () { submitBtn.disabled = true; }, 0);
        }
      });

      refreshConds();
      showStep(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReservation(document); });
  } else {
    initReservation(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReservation(event.target);
  });
})();
